import { Environment } from '@ilg-core/inscalar-web'

export const getInscalarAppEnv = (): Environment =>
    // NOTE: Business not ready for production yet so using test for both environment
    process.env.NEXT_PUBLIC_APP_ENV === 'production' ? 'test' : 'test'
